import { ReactComponent as FlagIcon } from "./svg/my-flag.svg";
import "../flag-icon.scss";

export const MYFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
